import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Chatbox from "../components/Chatbox";
import Tabs from "../components/meeting_details/Tabs";
import Screen from "../components/meeting_details/Screen";

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary
		// height: "72.5vh"
	}
}));

export default function FullWidthGrid() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Grid container spacing={3} style={{ height: "72.5vh" }}>
				<Grid item xs={12} sm={8}>
					<Paper
						className={classes.paper}
						style={{
							height: "100%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center"
						}}
						id="view-box"
					>
						<Screen />
					</Paper>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Chatbox></Chatbox>
				</Grid>
			</Grid>
			<Grid container spacing={3} className="mt-5">
				<Grid item xs={12}>
					<Tabs></Tabs>
				</Grid>
			</Grid>
		</div>
	);
}
